export const AccountCategory = [
	{ label: "--None--", value: "" },
	{ label: "I", value: "I" },
	{ label: "C", value: "C" },
];

export const AccountType = [
	{ label: "--None--", value: "" },
	{ label: "C", value: "C" },
	{ label: "S", value: "S" },
];
export const titleResponsibility = [
	{ label: "--Select--", value: "" },
	{ label: "Broker", value: "Broker" },
	{ label: "Dealer", value: "Dealer" },
	{ label: "North Mill", value: "North Mill" },
	{ label: "Non-Titled", value: "Non-Titled" },
];

export const VerbalDnAAddress = [
	{ label: "--None--", value: "" },
	{ label: "Business Address", value: "Business Address" },
	{ label: "Home Address", value: "Home Address" },
	{ label: "PO Box", value: "PO Box" },
];

export const ApplicationStatus = [
	"New",
	"Submitted",
	"Pre-Credit Review",
	"Credit Review",
	"Dealmaker",
	"Document Sent",
	"Funding",
	"Document Data Revicw",
	"TLO Pull",
];

export const franchiseType = [
	{ label: "--None--", value: "" },
	{ label: "Restaurant", value: "Restaurant" },
	{ label: "Salon", value: "Salon" },
];

export const franchiseNameRestaurant = [
	{ label: "--None--", value: "" },
	{ label: "Dickey’s Barbeque Pit", value: "Dickey’s Barbeque Pit" },
	{ label: "Your Pie", value: "Your Pie" },
	{ label: "Salata", value: "Salata" },
	{ label: "Blaze Pizza", value: "Blaze Pizza" },
	{ label: "Jersey Mikes", value: "Jersey Mikes" },
	{ label: "Which Wich", value: "Which Wich" },
	{ label: "Krispy Kreme", value: "Krispy Kreme" },
	{ label: "Taco Bell", value: "Taco Bell" },
	{ label: "Burger King", value: "Burger King" },
	{ label: "Subway", value: "Subway" },
	{ label: "Dunkin Doughnut", value: "Dunkin Doughnut" },
	{ label: "KFC", value: "KFC" },
	{ label: "Dominos Pizza", value: "Dominos Pizza" },
	{ label: "Papa Johns", value: "Papa Johns" },
	{ label: "Pizza Hut", value: "Pizza Hut" },
	{ label: "Firehouse", value: "Firehouse" },
];

export const franchiseNameSalon = [
	{ label: "--None--", value: "" },
	{ label: "Anytime Fitness", value: "Anytime Fitness" },
	{ label: "Great Clips", value: "Great Clips" },
];

export const States = [
	{ label: "--None--", value: "" },
	{ label: "Alaska", value: "AK" },
	{ label: "Alabama", value: "AL" },
	{ label: "Arkansas", value: "AR" },
	{ label: "Arizona", value: "AZ" },
	{ label: "California", value: "CA" },
	{ label: "Colorado", value: "CO" },
	{ label: "Connecticut", value: "CT" },
	{ label: "Washington DC", value: "DC" },
	{ label: "Delaware", value: "DE" },
	{ label: "Florida", value: "FL" },
	{ label: "Georgia", value: "GA" },
	{ label: "Hawaii", value: "HI" },
	{ label: "Iowa", value: "IA" },
	{ label: "Idaho", value: "ID" },
	{ label: "Illinois", value: "IL" },
	{ label: "Indiana", value: "IN" },
	{ label: "Kansas", value: "KS" },
	{ label: "Kentucky", value: "KY" },
	{ label: "Louisiana", value: "LA" },
	{ label: "Massachusetts", value: "MA" },
	{ label: "Maryland", value: "MD" },
	{ label: "Maine", value: "ME" },
	{ label: "Michigan", value: "MI" },
	{ label: "Minnesota", value: "MN" },
	{ label: "Missouri", value: "MO" },
	{ label: "Mississippi", value: "MS" },
	{ label: "Montana", value: "MT" },
	{ label: "North Carolina", value: "NC" },
	{ label: "North Dakota", value: "ND" },
	{ label: "Nebraska", value: "NE" },
	{ label: "New Hampshire", value: "NH" },
	{ label: "New Jersey", value: "NJ" },
	{ label: "New Mexico", value: "NM" },
	{ label: "Nevada", value: "NV" },
	{ label: "New York", value: "NY" },
	{ label: "Ohio", value: "OH" },
	{ label: "Oklahoma", value: "OK" },
	{ label: "Oregon", value: "OR" },
	{ label: "Pennsylvania", value: "PA" },
	{ label: "Rhode Island", value: "RI" },
	{ label: "South Carolina", value: "SC" },
	{ label: "South Dakota", value: "SD" },
	{ label: "Tennessee", value: "TN" },
	{ label: "Texas", value: "TX" },
	{ label: "Utah", value: "UT" },
	{ label: "Virginia", value: "VA" },
	{ label: "Vermont", value: "VT" },
	{ label: "Washington", value: "WA" },
	{ label: "Wisconsin", value: "WI" },
	{ label: "West Virginia", value: "WV" },
	{ label: "Wyoming", value: "WY" },
	{ label: "District of Columbia", value: "D2" },
];

export const SoleBusinessEntityType = [
	{ label: "--None--", value: "" },
	{ label: "Sole Proprietorship", value: "Sole Proprietorship" },
];

export const BusinessEntityType = [
	{ label: "--None--", value: "" },
	{ label: "Corporation", value: "Corporation" },
	{ label: "LLC", value: "LLC" },
	{ label: "LLP", value: "LLP" },
	{ label: "Partnership", value: "Partnership" },
	{ label: "Other", value: "Other" },
	{ lable: "Sole Proprietorship", value: "Sole Proprietorship" },
];

export const Address2Types = [
	{ label: "--None--", value: "" },
	{ label: "Apt", value: "Apt" },
	{ label: "Unit", value: "Unit" },
	{ label: "Suite", value: "Suite" },
	{ label: "Floor", value: "Floor" },
	{ label: "Building", value: "Building" },
];

export const YesNo = [
	{ label: "--None--", value: "" },
	{ label: "Yes", value: "Yes" },
	{ label: "No", value: "No" },
];

export const ApplicantType = {
	SOLE: "Sole Proprietor",
	BUSINESS: "Business",
};

export const GuarantorType = {
	SELF: "Self",
	PERSONAL: "Personal",
	CORPORATE: "Corporate",
};

export const Salutations = [
	{ label: "Mr.", value: "Mr." },
	{ label: "Ms.", value: "Ms." },
	{ label: "Mrs.", value: "Mrs." },
	{ label: "Dr.", value: "Dr." },
	{ label: "Prof.", value: "Prof." },
];

export const MaritalStatus = [
	{ label: "Single", value: "Single" },
	{ label: "Married", value: "Married" },
	{ label: "Divorced", value: "Divorced" },
	{ label: "Widowed", value: "Widowed" },
	{ label: "Unknown", value: "Unknown" },
];
export const guarantorPaymentDueDateRange = [
	{
		label: 1,
		value: 1,
	},
	{
		label: 2,
		value: 2,
	},
	{
		label: 3,
		value: 3,
	},
	{
		label: 4,
		value: 4,
	},
	{
		label: 5,
		value: 5,
	},
	{
		label: 6,
		value: 6,
	},
	{
		label: 7,
		value: 7,
	},
	{
		label: 8,
		value: 8,
	},
	{
		label: 9,
		value: 9,
	},
	{
		label: 10,
		value: 10,
	},
	{
		label: 11,
		value: 11,
	},
	{
		label: 12,
		value: 12,
	},
	{
		label: 13,
		value: 13,
	},
	{
		label: 14,
		value: 14,
	},
	{
		label: 15,
		value: 15,
	},
	{
		label: 16,
		value: 16,
	},
	{
		label: 17,
		value: 17,
	},
	{
		label: 18,
		value: 18,
	},
	{
		label: 19,
		value: 19,
	},
	{
		label: 20,
		value: 20,
	},
	{
		label: 21,
		value: 21,
	},
	{
		label: 22,
		value: 22,
	},
	{
		label: 23,
		value: 23,
	},
	{
		label: 24,
		value: 24,
	},
	{
		label: 25,
		value: 25,
	},
	{
		label: 26,
		value: 26,
	},
	{
		label: 27,
		value: 27,
	},
	{
		label: 28,
		value: 28,
	},
];
